<div [id]="id" class="svg-icon" [ngClass]="classes" [innerHTML]="svgIcon | safeHtml" (mouseover)="onMouseOver()"
  (mouseout)="onMouseOver()" [style.width.rem]="size" [style.height.äuto]></div>
<span class="badge" *ngIf="dataBadge !== null && dataBadge > 0">{{dataBadge}}</span>